import { useEffect, useState } from "react";
import CreateDomain from "./CreateDomain";
import EmailBlacklistList from "./EmailBlacklistList";
import { CampaignService } from "../../services/CampaignService";
import { toast } from "react-toastify";
import { EmailBlacklistService } from "../../services/EmailBlacklistService";
import DeleteDomain from "./DeleteDomain";

export default function EmailBlacklistDetails({
  showCreateModal,
  setShowCreateModal,
}) {
  const [domain, setDomain] = useState({});
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteError, setDeleteError] = useState(false);

  const getEmailBlacklist = () => {
    EmailBlacklistService.list().then((res) => {
      setList(res?.data);
    });
  };

  const createDomain = (domain) => {
    setLoading(true);
    EmailBlacklistService.create(domain)
      .then((res) => {
        if (res && res?.result) {
          toast.success("Email blacklist domain created successfully.");
        }
      })
      .finally(() => {
        setLoading(false);
        getEmailBlacklist();
        setShowCreateModal(false);
      });
  };

  const deleteDomain = (domain) => {
    setLoading(true);
    EmailBlacklistService.delete(domain?._id)
      .then((res) => {
        if (res && res?.result) {
          toast.success("Domain deleted successfully.");
          getEmailBlacklist();
          setShowDeleteModal(false);
        } else {
          setDeleteError(true);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getEmailBlacklist();
  }, []);

  return (
    <>
      <div className="card">
        <EmailBlacklistList
          list={list}
          onDelete={(domain) => {
            setDomain(domain);
            setShowDeleteModal(true);
          }}
        />
      </div>
      {showCreateModal && (
        <CreateDomain
          loading={loading}
          showModal={showCreateModal}
          onClose={() => {
            setShowCreateModal(false);
          }}
          onCreate={createDomain}
        ></CreateDomain>
      )}

      {showDeleteModal && (
        <DeleteDomain
          domain={domain}
          showModal={showDeleteModal}
          loading={loading}
          onClose={() => {
            setShowDeleteModal(false);
          }}
          onDelete={deleteDomain}
          deleteError={deleteError}
        />
      )}
    </>
  );
}
